import React from "react";
import FilterHeader from "../components/filters/FilterHeader";
import JobList from "../components/joblists/JobList";

const HomePage = () => {
  return (
    <>
      <FilterHeader />
      <JobList />
    </>
  );
};

export default HomePage;
